import { render } from "./Scorer.vue?vue&type=template&id=5276c2bd"
import script from "./Scorer.vue?vue&type=script&lang=js"
export * from "./Scorer.vue?vue&type=script&lang=js"

import "./Scorer.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script